'use client'

import { useSchedule } from '@/src/lib/hooks/useSchedule'
import { ErrorBoundary } from 'next/dist/client/components/error-boundary'
import { Suspense } from 'react'
import { SilentErrorFallback } from '../common/silent-error-boundary'

function ScheduleContent() {
  const { data: schedule } = useSchedule()

  return (
    <>
      {schedule?.days?.length > 0 && (
        <h3 className="text-xl font-bold mb-4">Horario</h3>
      )}
      <div className="flex flex-col space-y-4 w-full">
        {schedule?.days?.map((day, index) => (
          <div key={index} className="flex flex-col">
            <div className="font-medium mb-1">{day.days}</div>
            {day.shifts.length === 1
              ? (
                  <div className="text-srperrito-cream/80">{day.shifts[0]}</div>
                )
              : (
                  <div className="grid grid-cols-2 gap-2">
                    {day.shifts.map((shift, shiftIndex) => (
                      <div key={shiftIndex} className="text-srperrito-cream/80">{shift}</div>
                    ))}
                  </div>
                )}
          </div>
        ))}
        <p className="text-xs text-srperrito-cream/60 mt-2 italic">*Nuestros horarios pueden cambiar en fechas específicas, te recomendamos verificar los mismos desde Google Maps.</p>
      </div>
    </>
  )
}

function ScheduleFallback() {
  return (
    <div className="flex flex-col space-y-4 w-full">
      <div className="text-srperrito-cream/80">Cargando horarios...</div>
    </div>
  )
}

export function FooterSchedule() {
  return (
    <ErrorBoundary errorComponent={SilentErrorFallback}>
      <Suspense fallback={<ScheduleFallback />}>
        <ScheduleContent />
      </Suspense>
    </ErrorBoundary>
  )
}
